import React, { useState } from 'react';

import { FormItem, CheckBox, Label } from 'components';
import ZimssaConstant from 'commons/ZimssaConstant';
import { LABEL_CARINFO_ETC, CAPTION_CAR_ETC } from 'commons/ZimssaString';

interface Props {
    inputName: string;
    onChangeHandle?: (value: string) => void;
}

function createEtcValue(etcArr: Array<{ idx: number; name: string }>): string {
    return etcArr
        .sort((x, y) => x.idx - y.idx)
        .map((item) => item.name)
        .join(' + ');
}

function FormCarEtc({ onChangeHandle, ...props }: Props): React.ReactElement {
    const [etc, setEtc] = useState<Array<{ idx: number; name: string }>>([]);
    const onClickCallback = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;

        const etcName = value.split('|')[0];
        const etcIdx = Number(value.split('|')[1]);

        if (checked) {
            setEtc([...etc, { idx: etcIdx, name: etcName }]);
            onChangeHandle && onChangeHandle(createEtcValue([...etc, { idx: etcIdx, name: etcName }]));
        } else {
            setEtc(etc.filter((item) => item.idx !== etcIdx));
            onChangeHandle && onChangeHandle(createEtcValue(etc.filter((item) => item.idx !== etcIdx)));
        }
    };

    return (
        <FormItem label={LABEL_CARINFO_ETC} itemSpace={10} itemType={'ROW-BETWEEN'} caption={<Label contents={CAPTION_CAR_ETC} color={'gray_opacity_600'} fontStyle={'caption'} />}>
            {ZimssaConstant.CAR_INFO.ETC.map((item, index) => (
                <CheckBox key={index} contents={item} value={`${item}|${index}`} {...props} onChangeHandle={onClickCallback} />
            ))}
        </FormItem>
    );
}

export default FormCarEtc;
